import { SELECT_CAR } from "../actions/cars";

const carsReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_CAR:
      return (state = { ...state, car: action.car });
      break;

    default:
      return state;
  }
};

export default carsReducer;
